import { render, staticRenderFns } from "./SliderClientes.vue?vue&type=template&id=39b9853c&scoped=true"
import script from "./SliderClientes.vue?vue&type=script&lang=js"
export * from "./SliderClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39b9853c",
  null
  
)

export default component.exports